import { colors } from '@material-ui/core';

export default {
  primary: {
    main: '#4285F4'
  },
  secondary: {
    main: '#FC1F49',
    dark: colors.red['A700']
  },
  text: {
    primary: colors.grey[800],
    secondary: colors.grey[600],
  },
  input: {
    bottomLine: colors.grey[200],
    inputText: colors.grey[600],
  },
  background: {
    default: "#FFFFFF"
  }
};
